import api from "@/services/api.ts";
import {AffinityGroup} from "@/types/AffinityGroup.ts";

const URL = "/affinity-groups";

export const getAffinityGroups = async (): Promise<AffinityGroup[]> => {
    const response = await api.get<AffinityGroup[]>(URL);
    return response.data;
};

export const createAffinityGroup = async (group: {name: string; nameFr: string;}): Promise<AffinityGroup> => {
    const response = await api.post<AffinityGroup>(URL, group);
    return response.data;
};

export const updateAffinityGroup = async (id: number, group: {name?: string; nameFr?: string;}): Promise<AffinityGroup> => {
    const response = await api.put<AffinityGroup>(`${URL}/${id}`, group);
    return response.data;
};

export const deleteAffinityGroup = async (id: number): Promise<void> => {
    await api.delete(`${URL}/${id}`);
};
